<template>
  <div v-if="staticTotalBrands >= minBrands" class="flex justify-around items-center overflow-hidden">
    <div
      v-for="(letter, index) in letters"
      :key="index"
      class="uppercase text-center py-5 px-3 text-lg font-bold"
      :class="classObject(letter)"
      @click="filter(letter)"
    >
      {{ letter.text }}
    </div>
  </div>
</template>

<script setup lang="ts">
const { $algolia } = useNuxtApp()

const emit = defineEmits(['search'])

interface Letter {
  text: string
  enabled: boolean
  selected: boolean
}

const staticTotalBrands = ref(0)
const minBrands = 30
const letters = ref<Letter[]>([])

staticTotalBrands.value = $algolia.searchContexts.brands.state.value.resultCount

letters.value = letterGroups().map((letter) => {
  const group = {
    text: letter,
    enabled: false,
    selected: false,
  }

  if ($algolia.searchContexts.brands.state.value.refinements.group)
    group.enabled = $algolia.searchContexts.brands.state.value.refinements.group.some(({ value }) => letter === value)

  return group
})

function filter(letter: Letter) {
  if (!letter.enabled) return

  $algolia.searchContexts.brands.clearRefinements().setQuery()

  letters.value.forEach((l) => {
    // if the letter is already selected then we want to unselect it,
    // otherwise we just need to check if the current letter is the same as the letter we passed to the function.
    l.selected = l.selected ? false : l.text === letter.text
  })

  if (letter.selected) $algolia.searchContexts.brands.addRefinements('group', letter.text)

  // emit up so it triggers a search
  emit('search')
}

function classObject(letter: Letter) {
  return {
    'text-white bg-gray-darker cursor-pointer': letter.selected,
    'text-gray-light cursor-default hover:bg-transparent focus:bg-transparent': !letter.enabled,
    'text-gray-dark hover:text-gray-darker focus:text-gray-darker cursor-pointer': !letter.selected && letter.enabled,
  }
}
</script>
